import React, { useState } from 'react';
import styled from 'styled-components';
import { ethers } from 'ethers';
import { Button, Modal, Form, Input, Message } from 'semantic-ui-react';
import SocialVaultContract from '../artifacts/contracts/SocialVault.sol/SocialVault.json';

interface ISellStakeProps {
  address: string;
  stakedAmount: string;
  targetAmount: string;
  url?: string;
  name: string;
  isSelling: boolean;
}

const SellStake = (props: ISellStakeProps): JSX.Element => {
  const [sellFor, setSellFor] = useState<string>('0');
  const [open, setOpen] = useState<boolean>(false);
  const [addressToSell, setAddressToSell] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const ethStaked = ethers.utils.formatEther(props.stakedAmount);
  const ethAmount = ethers.utils.formatEther(props.targetAmount);

  function bringUpModal(address: string) {
    setErrorMessage('');
    setAddressToSell(address);
    setOpen(true);
  }

  async function sell() {
    try {
      setLoading(true);
      const provider: any = new ethers.providers.Web3Provider((window as any).ethereum);
      const userSocialVault: any = new ethers.Contract(
        addressToSell,
        SocialVaultContract.abi,
        provider.getSigner(0)
      );

      await userSocialVault.sellStake(ethers.utils.parseEther(sellFor));
      setOpen(false);
    } catch (e) {
      setErrorMessage((e as Error).message);
    }

    setLoading(false);
  }

  const percent = (parseFloat(ethStaked) / parseFloat(ethAmount)) * 100;

  return(
    <>
    <CardDiv>
      <ColumnOne>
          <img style={{width: "38px"}} src={props.url}/>
        </ColumnOne>
        <ColumnTwo>
          { props.name }
        </ColumnTwo>
        <ColumnEight>
          { `${percent}%` } <span style={{fontWeight: "bold"}}>{ `  (${ethStaked} ETH)` }</span>
        </ColumnEight>
        <ColumnOne>
          { props.isSelling ?
            <p style={{fontWeight: "bold"}}>on sale</p>
            :
            <p style={{fontWeight: "bold", cursor: "pointer"}} onClick={() => bringUpModal(props.address)}>sell</p>
          }
        </ColumnOne>
    </CardDiv>
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
    >
      <Modal.Header>How much would you like to sell your stake for?</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form error={!!errorMessage}>
          <Form.Field>
            <label>Sell Stake For</label>
            <Input
                label="eth"
                labelPosition="right"
                value={sellFor}
                onChange={event => setSellFor(event.target.value)}
            />
            </Form.Field>
            <Message error header="Oops!" content={errorMessage} />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          content="Sell"
          labelPosition='right'
          icon='checkmark'
          onClick={() => sell()}
          positive
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
    </>
  )
}

export const ColumnOne = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 6.25%;
`;

export const ColumnTwo = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 12.50%;
`;

export const ColumnEight = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 50%;
`;

export const CardDiv = styled.div`
    margin-top: 10px;
    background: #DCDCDC;
    width: 100%;
    font-size: 0.6em;
    border-radius: 0px;
    float: none;
    height: 60px;
    color: black;
`;

export default SellStake;
